"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _default = {
  props: ['editItem', 'merchantList'],
  data: function data() {
    return {
      form: {
        orderIds: '',
        merchantChildId: 0
      },
      dialogVisible: false,
      rules: {
        merchantChildId: [{
          required: true,
          message: '请选择跟单成员',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    init: function init() {
      this.form = {
        orderIds: this.editItem.orderId,
        merchantChildId: this.editItem.merchantChildId
      };
    },
    submit: function submit() {
      var _this = this;
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          (0, _merchant.setAuditOrder)(_this.form).then(function (res) {
            _this.$message.success("操作成功");
            _this.dialogVisible = false;
            _this.$emit('getList', true);
            _this.$emit('getMerchantChildList');
          }).catch(function () {});
        } else {
          _this.$message({
            message: "请检查表单错误",
            type: "error"
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;